import { RANGE_SP } from '@namespace/common/rangeSp'
import { UA_TABLET } from '@namespace/common/uaTablet'
import { UA_CLASS } from '@namespace/common/uaClass'
// import { HEADER } from '@namespace/common/header'
import { GNAV } from '@namespace/common/gnav'
import { LOCATION_CHECK } from '@namespace/common/locationCheck'
import { SMOOTH_SCROLL } from '@namespace/common/smoothScroll'
import { SCROLL_TOP } from '@namespace/common/scrollTop'
import { GALLERY_LIGHTBOX } from '@namespace/common/galleryLightbox'
// import { SEPARATE_WITH_SPAN } from '@namespace/common/separateWithSpan';
import { SWIPER } from '@namespace/common/swiper'
import { SWIPER_FACILITIES } from '@namespace/common/swiper'

/**
 * 共通初期化処理
 * - 各モジュールの初期化を一元管理
 */
export default function common() {
  const GLOBALSITE = {
    COMMON: {
      VARIABLES: {
        range_sp: true,
      },
      init() {
        this.RANGE_SP.init(this.VARIABLES)
        this.UA_TABLET.init()
        this.UA_CLASS.init()
        // this.HEADER.init()
        this.GNAV.init(GLOBALSITE)
        this.LOCATION_CHECK.init()
        this.SMOOTH_SCROLL.init()
        this.SCROLL_TOP.init()
        this.GALLERY_LIGHTBOX.init('[id^="gallery"]')
        this.GALLERY_LIGHTBOX.init('.wp-block-gallery > .wp-block-image')
        // this.SEPARATE_WITH_SPAN.init();
        this.SWIPER.init()
        this.SWIPER_FACILITIES.init()
      },
      RANGE_SP,
      UA_TABLET,
      UA_CLASS,
      // HEADER,
      GNAV,
      LOCATION_CHECK,
      SMOOTH_SCROLL,
      SCROLL_TOP,
      GALLERY_LIGHTBOX,
      // SEPARATE_WITH_SPAN,
      SWIPER,
      SWIPER_FACILITIES
    },
  }

  // DOM構築完了後に初期化
  document.addEventListener('DOMContentLoaded', () => {
    GLOBALSITE.COMMON.init()
  })

  // ページ完全読み込み後に body にクラスを追加
  window.addEventListener('load', () => {
    document.body.classList.add('initialized')
  })
}
